import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authHelpers } from '../global/supabase';
import '../global/styles.css';

function ForgotPassword({ onResetRequest }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const { data, error } = await authHelpers.resetPassword(email);

      if (error) {
        setError(error.message);
      } else {
        setMessage('Password reset link sent! Check your email. Click the link in your email to reset your password.');
        // Don't navigate - user should stay on this page and click the email link
      }
    } catch (err) {
      setError('An unexpected error occurred');
    }

    setLoading(false);
  };

  return (
    <div className="container-center">
      <div className="card">
        <h2 className="title-auth">Reset Password</h2>
        <p className="subtitle-auth">Enter your email address and we'll send you a link to reset your password</p>
        
        {error && (
          <div className="message error">
            {error}
          </div>
        )}

        {message && (
          <div className="message success">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="form-input"
              placeholder="Enter your email address"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="links">
          <div className="link-center">
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="link"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              {message ? 'Return to Login' : 'Back to Login'}
            </button>
          </div>
          {message && (
            <div className="link-center" style={{ marginTop: '10px' }}>
              <p className="text-small">
                Didn't receive the email? Check your spam folder or try again with a different email address.
              </p>
            </div>
          )}
        </div>
      </div>

      <footer className="footer">
        <p className="text-small">NarcoticTrack © 2025 NarcoticTrack Inventory System, LLC</p>
      </footer>
    </div>
  );
}

export default ForgotPassword;